export default function containsMeaning(meaning, text, partialText) {
  return (
    text.indexOf(meaning) >= 0 ||
    (partialText.length > 5 &&
      meaning.replace(/\s+\(\S{1,4}\)\s+/g, " ").indexOf(partialText) >= 0)
  );
}
